module.exports = __webpack_public_path__ + "prototype.jpg?a1ec3e0098e3dd4cbed382d0c2336457";